import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider, Day } from '@material-ui/pickers';
import moment from 'moment';

function Calendar(props) {
    const { dates } = props;
    const lang = localStorage.getItem("lang") || "en";

    const renderPickerDay = (date) => {
        if (dates && dates.includes(moment(date).format('YYYY-MM-DD'))) {
            return <Day {...props}
                    selected={true}
                    >{moment(date).format('DD')}</Day>
        } else {
            return <Day {...props} 
                    >{moment(date).format('DD')}</Day>
        }
    };

    // console.log(dates)

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} local={lang === 'ar' ? 'ar-SA' : 'en-US'}>
            <DatePicker
                autoOk
                disableToolbar={true}
                orientation="landscape"
                variant="static"
                openTo="date"
                value={moment().format('YYYY-MM-DD')}
                onChange={(date) => console.log(date)}
                readOnly={true}
                renderDay={renderPickerDay}
            />
        </MuiPickersUtilsProvider>
    )
}

export default Calendar